import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ICategoriesState, ICategory } from '../../types/store';

const initialState: ICategoriesState = {
  content: [],
  page: {
    size: 0,
    number: 0,
    totalElements: 0,
    totalPages: 0,
  },
};

const categoriesSlice = createSlice({
  name: 'categoriesSlice',
  initialState,
  reducers: {
    setCategories: (state, action) => {
      state.content = action.payload.content;
      state.page = action.payload.page;
    },
    syncCategories: (state, action) => {
      state.content = action.payload;
    },
    toggleCategory: (state, action: PayloadAction<ICategory>) => {
      const index = state.content.findIndex((x) => x.name === action.payload.name);

      if (index !== -1) {
        state.content[index] = action.payload;
      }
    },
  },
});

export const { setCategories, syncCategories, toggleCategory } = categoriesSlice.actions;

export default categoriesSlice.reducer;
